module.exports = __webpack_public_path__ + "img/cost-dots.aaf9449a.svg";